import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ScheduleAddDialogComponent } from '@fi-shared/checklist/schedule/schedule-edit/add-dialog/add-dialog.component';
import { FormsModule } from '@angular/forms';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { MatRadioModule } from '@angular/material/radio';
import { FiChecklist2ScheduleEditComponent } from './schedule-edit.component';
import { FiChecklist2TimeIntervalsComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/time-intervals/time-intervals.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiEditPublicationModule } from '@fi-shared/fi-edit-publication';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiAccessRightFiltersModule } from '@fi-shared/access-right-filters';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiTranslationRadioGroupModule } from '@fi-shared/fi-translation-radio-group/fi-translation-radio-group.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FiChecklist2ScheduleRolesEditorDialogComponent } from '@fi-shared/checklist/schedule/schedule-edit/roles-settings/roles-editor-dialog/roles-editor-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiSectionCardModule } from '@fi-shared/fi-section-card/fi-section-card.module';
import { FiChecklist2ScheduleEditRolesSettingsComponent } from '@fi-shared/checklist/schedule/schedule-edit/roles-settings/roles-settings.component';
import { FiChecklist2ScheduleEditGeneralInfoComponent } from '@fi-shared/checklist/schedule/schedule-edit/general-info/general-info.component';
import { FiCheckbox2Module } from '@fi-shared/fi-checkbox2/fi-checkbox2.module';
import { FiChecklist2ScheduleEditScheduleTimeComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/schedule-time.component';
import { FiChecklist2ScheduleEditUnitAssignmentComponent } from '@fi-shared/checklist/schedule/schedule-edit/unit-assignment/unit-assignment.component';
import { FiChecklist2ScheduleEditTimeIntervalsDialogComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/time-intervals-dialog/time-intervals-dialog.component';
import { FiChecklist2ScheduleEditScheduleTypeComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/schedule-type/schedule-type.component';
import { FiChecklist2ScheduleEditTimeIntervalTypeComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/time-interval-type/time-interval-type.component';
import { MatSelectModule } from '@angular/material/select';
import { FiTimePickerPopupModule } from '@fi-app/components/time-picker-popup/time-picker-popup.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FiChecklist2TimeIntervalComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/time-intervals/time-interval/time-interval.component';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { MatDividerModule } from '@angular/material/divider';
import { FiChecklist2TimeIntervalsViewerComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/time-intervals/time-intervals-viewer/time-intervals-viewer.component';
import { FiChecklist2ScheduleRemindTimeComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/remind-time/remind-time.component';
import { FiChecklist2TimeIntervalSettingsComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-time/time-intervals/time-interval-settings/time-interval-settings.component';
import { FiChecklist2ScheduleDescriptionModule } from '@fi-shared/checklist/fi-checklist2-schedule-description/fi-checklist2-schedule-description.module';
import { FiChecklist2TranslationModule } from '@fi-shared/checklist/fi-checklist2-translation/fi-checklist2-translation.module';
import { FiTimePickerInputModule } from '@fi-shared/fi-time-picker-input/fi-time-picker-input.module';
import { FiThreeColumnsContainerModule } from '@fi-shared/fi-three-columns-container/fi-three-columns-container.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiValidatingFormModule,
        MatRadioModule,
        FiAppTextSharedModule,
        SelectSearchModule,
        FiEditPublicationModule,
        FiErrorMessageModule,
        FiAccessRightFiltersModule,
        MatFormFieldModule,
        MatInputModule,
        FiTwoColumnsContainerModule,
        FiTranslationRadioGroupModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatCheckboxModule,
        FiSectionCardModule,
        FiCheckbox2Module,
        MatSelectModule,
        FiTimePickerPopupModule,
        NgxMaterialTimepickerModule,
        FiToggleSwitchModule,
        MatDividerModule,
        FiChecklist2ScheduleDescriptionModule,
        FiChecklist2TranslationModule,
        FiTimePickerInputModule,
        FiThreeColumnsContainerModule,
        InfoIconModule,
        FiTooltipModule,
        FiNameInputModule,
    ],
    declarations: [
        FiChecklist2ScheduleAddDialogComponent,
        FiChecklist2ScheduleEditComponent,
        FiChecklist2TimeIntervalsComponent,
        FiChecklist2ScheduleRolesEditorDialogComponent,
        FiChecklist2ScheduleEditGeneralInfoComponent,
        FiChecklist2ScheduleEditRolesSettingsComponent,
        FiChecklist2ScheduleEditScheduleTimeComponent,
        FiChecklist2ScheduleEditUnitAssignmentComponent,
        FiChecklist2ScheduleEditTimeIntervalsDialogComponent,
        FiChecklist2ScheduleEditScheduleTypeComponent,
        FiChecklist2ScheduleEditTimeIntervalTypeComponent,
        FiChecklist2TimeIntervalComponent,
        FiChecklist2TimeIntervalsViewerComponent,
        FiChecklist2ScheduleRemindTimeComponent,
        FiChecklist2TimeIntervalSettingsComponent,
    ],
})
export class FiChecklist2ScheduleEditModule {}
